import { safelyGetLocalStorage, safelySetLocalStorage, safelyRemoveFromLocalStorage } from '../utils/storage';
import { SESSION_STORAGE_KEY } from './constants';
import { isSessionDurationExceeded, isSessionInactivityTimeoutReached, isSessionState } from './utils';
import { throttle } from '../utils/throttle';
export const localStore = {
    cachedValue: undefined,
    set: (value) => {
        localStore.cachedValue = value;
        localStore._set(value);
    },
    flush: () => {
        localStore._set.flush();
    },
    _set: throttle((value) => {
        safelySetLocalStorage(SESSION_STORAGE_KEY, value);
    }, 1000),
    get: ({ forceStoreRead }) => {
        if (localStore.cachedValue === undefined || forceStoreRead) {
            localStore.cachedValue = safelyGetLocalStorage(SESSION_STORAGE_KEY);
            return localStore.cachedValue;
        }
        return localStore.cachedValue;
    },
    remove: () => {
        safelyRemoveFromLocalStorage(SESSION_STORAGE_KEY);
        localStore.cachedValue = undefined;
    },
};
export const getSessionStateFromLocalStorage = ({ forceStoreRead, }) => {
    let sessionState = undefined;
    try {
        sessionState = JSON.parse(localStore.get({ forceStoreRead }));
    }
    catch (_a) {
        return undefined;
    }
    if (!isSessionState(sessionState)) {
        return;
    }
    if (isSessionDurationExceeded(sessionState) || isSessionInactivityTimeoutReached(sessionState)) {
        return;
    }
    return sessionState;
};
export const setSessionStateToLocalStorage = (sessionState, { forceStoreWrite }) => {
    if (isSessionDurationExceeded(sessionState)) {
        return;
    }
    localStore.set(JSON.stringify(sessionState));
    if (forceStoreWrite) {
        localStore.flush();
    }
};
export const clearSessionStateFromLocalStorage = () => {
    localStore.remove();
};
//# sourceMappingURL=local-storage-session.js.map